import type { HttpHandler } from 'msw';
import type { MSWConfig } from '../utils/config-loader';
import { isEndpointEnabled } from '../utils/config-loader';
import { createBookingHandlers } from './bookings';
import { createSubscriptionHandlers } from './subscriptions';
import { createBillingHandlers } from './billing';
import { createRegistrationHandlers } from './registration';
import { createPaymentHandlers } from './payment';
import { createBeneficiaryHandlers } from './beneficiaries';
import { createGeographyHandlers } from './geography';
import { createCampaignHandlers } from './campaigns';

/**
 * Get all MSW handlers
 * @param config - MSW configuration
 * @param overrideHandlers - Optional array of MSW request handlers to override
 * @param baseUrl - Base URL for the BFF gateway
 * @returns Array of MSW request handlers
 */
export function createHandlers(baseUrl: string, config: MSWConfig, overrideHandlers?: HttpHandler[]): HttpHandler[] {
  // Create handlers with the base URL

  const sanitizedBaseUrl = baseUrl.replace(/\/$/, '');
  const allHandlers = [
    ...createBookingHandlers(sanitizedBaseUrl),
    ...createSubscriptionHandlers(sanitizedBaseUrl),
    ...createBillingHandlers(sanitizedBaseUrl),
    ...createRegistrationHandlers(sanitizedBaseUrl),
    ...createPaymentHandlers(sanitizedBaseUrl),
    ...createBeneficiaryHandlers(sanitizedBaseUrl),
    ...createGeographyHandlers(sanitizedBaseUrl),
    ...createCampaignHandlers(sanitizedBaseUrl),
  ];

  // Filter handlers based on the MSW config file
  const filteredHandlers = allHandlers.filter(handler => isEndpointEnabled(config, handler.mapping.key));

  // Override handlers are placed last so MSW's first-match rule gives them priority
  // They bypass endpoint filtering — when provided they are always active
  const overrides = overrideHandlers ?? [];

  console.log('[MSW] Enabled handlers:', filteredHandlers.map(handler => handler.mapping.key));
  if (overrides.length > 0) {
    console.log('[MSW] Override handlers active:', overrides.length);
  }

  return [...overrides, ...filteredHandlers.map(handler => handler.handler)];
}


